// Maps project id -> "Cliente NN": ranking order first, then remaining projects in list order.
export const buildPrivateLabels = (rankingIds = [], projects = []) => {
  const map = {};
  let n = 0;
  const add = (id) => {
    if (!id || map[id]) return;
    n += 1;
    map[id] = `Cliente ${String(n).padStart(2, '0')}`;
  };
  rankingIds.forEach(add);
  projects.forEach((p) => add(p.id));
  return map;
};
